import { useEffect, useRef, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import "./styles.css";
import api from "../../../services/api";

import moment from "moment";
// Não fiz com loop, eu sei
const PERCENTUAIS = [100, 99, 98, 97, 96, 95, 94, 93, 92, 91, 90, 89, 88, 87, 86, 85, 84, 83, 82, 81, 80];

export const MetaDiaria = () => {
    const [data, setData] = useState([]);
    const [dates, setDates] = useState([]);
    const [currentDate, setCurrentDate] = useState(null);
    const [baseDate, setBaseDate] = useState(new Date());
    const [eficiencias, setEficiencias] = useState([]);
    const [turmaCores, setTurmaCores] = useState({});
    const [grupos, setGrupos] = useState([]);
    const [loading, setLoading] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    // const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const GroupTable = ({ dados = { dados: [], grupo: '' } }) => {
        let turmas = { '1': 0, '2': 0, '3': 0, '4': 0 };

        dados.dados.forEach((el) => {
            turmas['1'] += parseFloat(el.turma1);
            turmas['2'] += parseFloat(el.turma2);
            turmas['3'] += parseFloat(el.turma3);
            turmas['4'] += parseFloat(el.turma4);
        });

        return (
            <div className="p-grid p-justify-center p-align-center">
                <div className="p-col-1">
                    <h2 style={{ backgroundColor: "#f1c40f", inlineSize: 'fit-content', padding: 16 }}>GRUPO {dados.grupo}</h2>
                </div>
                <div className="p-col-11">
                    <DataTable
                        footer={() => {
                            let _dados = [...dados.dados];
                            let item = {};

                            PERCENTUAIS.forEach((p) => {
                                item[p] = 0;
                            });

                            _dados.forEach((d) => {
                                PERCENTUAIS.forEach((p) => {
                                    item[p] += d.batida > 0 ? parseInt((p / 100) * 720 * (d.rpm / (d.batida * 100))) : 0;
                                });
                            });

                            return (
                                <div className="p-d-flex p-justify-between">
                                    {PERCENTUAIS.map((p, i) => (
                                        <div className="p-d-flex p-flex-column" key={`div${i}`}>
                                            <span className="p-text-center">{p}%</span>
                                            <span className="p-text-center">{item[p]}</span>
                                        </div>
                                    ))}
                                </div>
                            )
                        }}
                        responsiveLayout="scroll"
                        size="small"
                        value={dados.dados}
                    >
                        <Column header='TEAR' field='tear' />
                        <Column header='ARTIGO' field='artigo' />
                        <Column header='BATIDA' field='batida' />
                        <Column header='RPM' field='rpm' />
                        {PERCENTUAIS.map((p, i) => (
                            <Column header={p + '%'} key={i} body={(rowData) => {
                                let percentual = parseInt((p / 100) * 720 * (rowData.rpm / (rowData.batida * 100)));
                                if(isNaN(percentual)){
                                    percentual = '';
                                }
                                let color = '#ffffff';
                                if(rowData.turma1 > 0 || rowData.turma2 > 0) {
                                    if(rowData.turma1eficiencia === rowData.turma2eficiencia && rowData.turma1eficiencia === p) {
                                        color = '#2980b9';
                                    } else {
                                        if(p === rowData.turma1eficiencia) {
                                            color = turmaCores[1];
                                        } else if(p === rowData.turma2eficiencia) {
                                            color = turmaCores[2];
                                        }
                                    }
                                } else {
                                    if(rowData.turma3eficiencia === rowData.turma4eficiencia && rowData.turma3eficiencia === p) {
                                        color = '#2980b9';
                                    } else {
                                        if(p === rowData.turma3eficiencia) {
                                            color = turmaCores[3];
                                        } else if(p === rowData.turma4eficiencia) {
                                            color = turmaCores[4];
                                        }
                                    }
                                }
                                return (
                                    <span
                                        style={{ backgroundColor: color, padding: 4, color: "#000" }}
                                    >{percentual}</span>
                                )
                            }} />
                        ))}
                    </DataTable>
                </div>
                <div className="p-col-11" style={{ marginBottom: 32 }}>
                    {turmas['1'] > 0 && (
                        <div className="p-d-flex p-flex-row">
                            <div style={{ height: "40px", width: "40px", margin: 4, backgroundColor: turmaCores[1] }}></div>
                            <p className="p-text-bold">Turma A: {turmas['1']}</p>
                        </div>
                    )}
                    {turmas['2'] > 0 && (
                        <div className="p-d-flex p-flex-row">
                            <div style={{ height: "40px", width: "40px", margin: 4, backgroundColor: turmaCores[2] }}></div>
                            <p className="p-text-bold">Turma B: {turmas['2']}</p>
                        </div>
                    )}
                    {turmas['3'] > 0 && (
                        <div className="p-d-flex p-flex-row">
                            <div style={{ height: "40px", width: "40px", margin: 4, backgroundColor: turmaCores[3] }}></div>
                            <p className="p-text-bold">Turma C: {turmas['3']}</p>
                        </div>
                    )}
                    {turmas['4'] > 0 && (
                        <div className="p-d-flex p-flex-row">
                            <div style={{ height: "40px", width: "40px", margin: 4, backgroundColor: turmaCores[4] }}></div>
                            <p className="p-text-bold">Turma D: {turmas['4']}</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (currentDate !== null) {
            setLoading(true);
            api.get('meta-diaria', {
                params: {
                    'data': moment(currentDate, "DD/MM/YYYY").format("YYYY-MM-DD")
                }
            }).then(response => {
                setLoading(false);
                let { data } = response;

                let grupos = [];

                data.forEach((item) => {
                    if (grupos.indexOf(item.grupo) === -1)
                        grupos.push(item.grupo);
                });

                let toRender = [];

                grupos.forEach((grupo) => {
                    let grupoObj = {};
                    grupoObj.grupo = grupo;
                    let grupoDados = data.filter((el) => { return el.grupo === grupo });
                    grupoObj.dados = grupoDados;
                    toRender.push(grupoObj);
                });

                let _eficiencias = [];

                PERCENTUAIS.forEach((p) => {
                    let item = { eficiencia: p + '%', total: 0 }
                    grupos.forEach((grupo) => {
                        item[grupo] = 0;
                        let grupoDados = data.filter((el) => { return el.grupo === grupo });
                        grupoDados.forEach((g) => {
                            item[grupo] += g.batida > 0 ? parseInt((p / 100) * 720 * (g.rpm / (g.batida * 100))) : 0;
                        });
                        item.total += parseFloat(item[grupo]);
                    });

                    item.x2 = item.total * 2;
                    _eficiencias.push(item);
                });

                setData(toRender);
                setGrupos(grupos);
                setEficiencias(_eficiencias);
            }).catch(error => {
                setLoading(false);
                showError(error);
            });
        }
    }, [currentDate]);

    useEffect(() => {
        if (baseDate !== null) {
            let data = new Date(baseDate.getTime());
            data.setDate(data.getDate() - 1);
            let labels = [];
            let i = 0;
            while (i < 15) {
                labels.push(moment(data).format('DD/MM/YYYY'));
                i += 1;
                if (i !== 15)
                    data.setDate(data.getDate() - 1);
            }
            setDates(labels.reverse());
        }
    }, [baseDate]);

    useEffect(() => {
        api.get('cadastros/turmas').then(response => {
            const { data } = response;
            let turmaCores = {};

            data.forEach((item) => {
                turmaCores[item.id] = item.hex;
            });

            setTurmaCores(turmaCores);
        }).catch(error => {
            console.log(error);
        });
    }, []);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Card
                        className="p-m-1"
                        style={{ height: '92vh', overflowY: 'scroll', padding: 16 }}
                        title='Meta Diária'
                    >
                        <div className="p-d-flex p-flex-row p-fluid">
                            <div className="field">
                                <label htmlFor="data_inicial">Data Base: </label>
                                <Calendar
                                    className="p-m-1"
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"
                                    onChange={e => setBaseDate(e.value)}
                                    value={baseDate}
                                />
                            </div>
                        </div>

                        <div className="p-d-flex p-flex-column">
                            {data.map((grupoDado) => {
                                return <GroupTable dados={grupoDado} />
                            })}
                        </div>

                        {eficiencias.length > 0 && (
                            <div className="p-grid">
                                <div className="p-col-6">
                                    <DataTable
                                        emptyMessage='Nenhum registro encontrado.'
                                        responsiveLayout="scroll"
                                        size="small"
                                        tableStyle={{ fontSize: 14 }}
                                        value={eficiencias}
                                    >
                                        <Column header='Eficiência' field='eficiencia' />
                                        {grupos.map((g, i) => (
                                            <Column key={i} header={`GRUPO ${g}`} field={String(g)} />
                                        ))}
                                        <Column header='Total' field='total' />
                                        <Column header='x2' field='x2' />
                                    </DataTable>
                                </div>
                            </div>
                        )}

                        <div className="p-d-flex p-flex-row p-grid" style={{ position: 'fixed', bottom: 24 }}>
                            {dates.map((date, index) => (
                                <button
                                    className={"p-col metadiaria-button " + (currentDate === date ? "metadiaria-button-selected" : "")}
                                    key={index}
                                    onClick={() => {
                                        setCurrentDate(date);
                                    }}
                                >
                                    {date}
                                </button>
                            ))}
                        </div>
                    </Card>
                </>
            )}
        </div>
    )
}